import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import FilterIcon from '../icons/FilterIcon';
import sizes from './sizes';
const FilterButton = ({ disabled, color, onClick, title, id, className, size, active, dataTestId, }) => (React.createElement(CircleButton, { dataTestId: dataTestId, id: id, size: size, className: className, color: color, disabled: disabled, onClick: onClick, title: title, active: active },
    React.createElement(FilterIcon, { className: "w-5 h-5" })));
FilterButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    color: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    active: PropTypes.bool,
    dataTestId: PropTypes.string,
};
FilterButton.defaultProps = {
    size: sizes.normal,
    color: 'brand',
    disabled: false,
    title: '',
    onClick: () => { },
    active: false,
    dataTestId: 'CircleButton-68e4bb22',
};
export default FilterButton;
